module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('Menu', {
    attrs: {
      "mode": "horizontal",
      "theme": "dark",
      "active-name": "1"
    }
  }, [_c('div', {
    staticClass: "layout-logo"
  }, [_c('h3', [_vm._v("管理系统")])]), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "header-search"
  }, [_c('MenuSearch')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-msg"
  }, [_c('Message')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-announcement"
  }, [_c('Announcement')], 1), _vm._v(" "), _c('div', {
    staticClass: "header-user"
  }, [(_vm.isLogin) ? _c('Dropdown', {
    attrs: {
      "placement": "bottom-end"
    },
    on: {
      "on-click": _vm.userMenuClick
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.mobile) + "\n          "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('Dropdown-item', {
    attrs: {
      "name": "logout"
    }
  }, [_vm._v("退出登录")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/login',
        query: {
          backUrl: this.$route.fullPath
        }
      }
    }
  }, [_vm._v("登录")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a6ecdac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/CommonHeader.vue
// module id = 1916
// module chunks = 8